import React, { Component, Fragment } from "react";
import { render } from "react-dom";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import { transitions, positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";

import Alerts from "./layout/Alerts";
import PrivateRoute from "./common/PrivateRoute";
import Login from "./accounts/Login";
import SingleLogin from "./accounts/SingleLogin";
import ResetPassword from "./accounts/ResetPassword";
import Homepage from "./Homepage";
import Preview from "./preview/Preview";

import { Provider } from "react-redux";
import store from "../store";
import { loadUser } from "../actions/auth";
import PdfViewer from "./common/PdfViewer";
import SharePdfViewer from "./common/SharePdfViewer";

import zhCN from "antd/lib/locale/zh_CN";
import { ConfigProvider } from "antd";
import zhCH5 from "antd-v5/lib/locale/zh_CN";
import { ConfigProvider as ConfigProvider5 } from 'antd-v5';

// 本地代理配置
import axios from 'axios'
axios.defaults.baseURL = '/frontApi'
import { checkOpen } from '../utils/common'

// Alert Options
const alertOptions = {
  timeout: 3000,
  position: positions.TOP_CENTER,
  transition: transitions.SCALE,
};

let isOpen = false
export default class App extends Component {

  state = {
    indexUrl: "",
  }
   

  componentDidMount() {
    let indexUrl = localStorage.getItem('indexUrl') || "/"

    let search = window.location.search
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('type=') == 0
    })
    if (obj) {
      let type = obj.split('=')[1]
      if (type == 'search') {
        let path = window.location.pathname
        indexUrl = path
      }
    }
    this.setState({
      indexUrl: indexUrl
    })
    let pathname = window.location.pathname
    if(pathname != '/singleLogin') {
      store.dispatch(loadUser());
    }


    // 禁止复制
    document.addEventListener('copy', function (e) {
      e.preventDefault();
    });
    // 禁止右键
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    });
    // 禁止Ctrl + c 、F12
    document.addEventListener("keydown", function (e) {
      if ((e.ctrlKey || e.metaKey) && e.key === 'c') {
          e.preventDefault();
        }
      if (e.keyCode === 123) {
        e.preventDefault();
      }
      if (e.keyCode === 119) {
        e.preventDefault();
      }
    });
    // debugger检查
    checkOpen()
  }

  


  render() {

    return (
      <Provider store={store}>
        <ConfigProvider locale={zhCN}>
          <ConfigProvider5 prefixCls="ant5" locale={zhCH5}>
            <AlertProvider template={AlertTemplate} {...alertOptions}>
              <Router>
                <Fragment>
                  <Alerts />
                  <Switch>
                    <PrivateRoute exact path={this.state.indexUrl} component={Homepage} />
                    <Route path="/login" component={Login} />
                    <Route path="/preview" component={Preview} />
                    <Route path="/singleLogin" component={SingleLogin} />
                    <Route path="/reset" component={ResetPassword} />
                    <Route path="/viewer" component={PdfViewer} />
                    <Route
                      path="/share_viewer/:file_id"
                      component={SharePdfViewer}
                    />
                    <Redirect to={this.state.indexUrl} />
                  </Switch>
                </Fragment>
              </Router>
            </AlertProvider>
          </ConfigProvider5>
        </ConfigProvider>
      </Provider>
    );
  }
}

const appDiv = document.getElementById("app");
render(<App />, appDiv);
